<template>
  <div>
    <vue-json-pretty :data="jsonData"></vue-json-pretty>
  </div>
</template>

<script>
import VueJsonPretty from "vue-json-pretty";
import "vue-json-pretty/lib/styles.css";

export default {
  props: {
    data: {
      type: Array,
      default: null,
    },
    options: {
      type: Object,
      default: null,
    },
  },
  computed: {
    jsonData() {
      const data = this.data;
      data.eventJson = JSON.parse(data.eventJson);
      return data;
    },
  },
  components: {
    VueJsonPretty,
  },
};
</script>

<style lang="scss" scoped></style>
